module.exports = __webpack_public_path__ + "img/2.fff66251.png";